module.exports = __webpack_public_path__ + "media/images/iconTrendUp__errorRed-b05a965a2e1b424d0347c82b7f2d0783.png";